import vine, { SimpleMessagesProvider } from '@vinejs/vine'

/**
 * Messages Vine en français (alignés sur l’API).
 * À importer avant tout `validate()` côté IHM.
 */
vine.messagesProvider = new SimpleMessagesProvider(
  {
    required: 'Le champ {{ field }} est obligatoire',
    'dirLib.required': 'Le nom court est obligatoire',
    string: 'Le champ {{ field }} doit être une chaîne de caractères',
    email: 'Le champ {{ field }} doit être une adresse e-mail valide',
    regex: 'Le format du champ {{ field }} est invalide',
    url: 'Le champ {{ field }} doit être une URL valide',
    activeUrl: 'Le champ {{ field }} doit être une URL valide',
    alpha: 'Le champ {{ field }} ne doit contenir que des lettres',
    alphaNumeric: 'Le champ {{ field }} ne doit contenir que des lettres et des chiffres',
    minLength: 'Le champ {{ field }} doit contenir au moins {{ min }} caractères',
    maxLength: 'Le champ {{ field }} ne doit pas contenir plus de {{ max }} caractères',
    fixedLength: 'Le champ {{ field }} doit contenir exactement {{ size }} caractères',
    confirmed: 'Le champ {{ field }} et le champ {{ otherField }} doivent être identiques',
    endsWith: 'Le champ {{ field }} doit se terminer par {{ substring }}',
    startsWith: 'Le champ {{ field }} doit commencer par {{ substring }}',
    sameAs: 'Le champ {{ field }} et le champ {{ otherField }} doivent être identiques',
    notSameAs: 'Le champ {{ field }} et le champ {{ otherField }} doivent être différents',
    in: 'Le champ sélectionné {{ field }} est invalide',
    notIn: 'Le champ sélectionné {{ field }} est invalide',
    ipAddress: 'Le champ {{ field }} doit être une adresse IP valide',
    uuid: 'Le champ {{ field }} doit être un UUID valide',
    ascii: 'Le champ {{ field }} ne doit contenir que des caractères ASCII',
    creditCard: 'Le champ {{ field }} doit être un numéro de carte {{ providersList }} valide',
    hexCode: 'Le champ {{ field }} doit être un code couleur hexadécimal valide',
    iban: 'Le champ {{ field }} doit être un numéro IBAN valide',
    jwt: 'Le champ {{ field }} doit être un jeton JWT valide',
    coordinates: 'Le champ {{ field }} doit contenir des coordonnées de latitude et de longitude',
    mobile: 'Le champ {{ field }} doit être un numéro de téléphone mobile valide',
    passport: 'Le champ {{ field }} doit être un numéro de passeport valide',
    postalCode: 'Le champ {{ field }} doit être un code postal valide',
    boolean: 'La valeur doit être un booléen',
    number: 'Le champ {{ field }} doit être un nombre',
    min: 'Le champ {{ field }} doit être au moins {{ min }}',
    max: 'Le champ {{ field }} ne doit pas dépasser {{ max }}',
    range: 'Le champ {{ field }} doit être compris entre {{ min }} et {{ max }}',
    positive: 'Le champ {{ field }} doit être positif',
    negative: 'Le champ {{ field }} doit être négatif',
    decimal: 'Le champ {{ field }} doit avoir {{ digits }} décimales',
    withoutDecimals: 'Le champ {{ field }} ne doit pas avoir de décimales',
    date: 'Le champ {{ field }} doit être une valeur de date et heure',
    'date.equals': 'Le champ {{ field }} doit être une date égale à {{ expectedValue }}',
    'date.after': 'Le champ {{ field }} doit être une date après {{ expectedValue }}',
    'date.before': 'Le champ {{ field }} doit être une date avant {{ expectedValue }}',
    'date.afterOrEqual': 'Le champ {{ field }} doit être une date après ou égale à {{ expectedValue }}',
    'date.beforeOrEqual': 'Le champ {{ field }} doit être une date avant ou égale à {{ expectedValue }}',
    'date.sameAs': 'Le champ {{ field }} et le champ {{ otherField }} doivent être identiques',
    'date.notSameAs': 'Le champ {{ field }} et le champ {{ otherField }} doivent être différents',
    'date.afterField': 'Le champ {{ field }} doit être une date après {{ otherField }}',
    accepted: 'Le champ {{ field }} doit être accepté',
    enum: 'Le champ sélectionné {{ field }} est invalide',
    'dirType.enum': 'Le type de direction est invalide',
    literal: 'Le champ {{ field }} doit être {{ expectedValue }}',
    object: 'Le champ {{ field }} doit être un objet',
    record: 'Le champ {{ field }} doit être un objet',
    'record.minLength': 'Le champ {{ field }} doit contenir au moins {{ min }} éléments',
    'record.maxLength': 'Le champ {{ field }} ne doit pas contenir plus de {{ max }} éléments',
    'record.fixedLength': 'Le champ {{ field }} doit contenir exactement {{ size }} éléments',
    array: 'Le champ {{ field }} doit être un tableau',
    'array.minLength': 'Le champ {{ field }} doit contenir au moins {{ min }} éléments',
    'array.maxLength': 'Le champ {{ field }} ne doit pas contenir plus de {{ max }} éléments',
    'array.fixedLength': 'Le champ {{ field }} doit contenir exactement {{ size }} éléments',
    notEmpty: 'Le champ {{ field }} ne doit pas être vide',
    distinct: 'Le champ {{ field }} contient des valeurs dupliquées',
    tuple: 'Le champ {{ field }} doit être un tableau',
    union: 'Valeur invalide fournie pour le champ {{ field }}',
    unionGroup: 'Valeur invalide fournie pour le champ {{ field }}',
    unionOfTypes: 'Valeur invalide fournie pour le champ {{ field }}',
    any: "Le champ {{ field }} peut être n'importe quelle valeur",
  },
  {
    dirType: 'type de direction',
    dirLib: 'nom court',
    dirLibLong: 'nom long',
    dirDesc: 'description',
  },
)
